export default __webpack_public_path__ + "static/media/ctabuttonSvg.645d1165.svg";